module.exports = __webpack_public_path__ + "static/media/juarez.ddb71211.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/centers/juarez.png
// module id = 619
// module chunks = 0